<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Delete File] - AMOS365'" />

            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="$root.getUrl(file)">{{ $root.getRecordName(file) }}</router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">Delete: {{ file.file_title ? file.file_title : file.file_name }}</li>
                </ol>
            </nav>

            <h4 class="page-header">
                Delete: {{ file.file_title ? file.file_title : file.file_name }}
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-lg-6 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Edit File</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this file. This cannot be undone.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-4 col-12 mt-md-0 mt-4">

                </div>
            </div>

            <div class="mt-4">
                <button type="button" class="btn btn-sm btn-danger" v-if="id" v-on:click="deleteFile()" :disabled="saving">
                    <template v-if="saving"><i class="fas fa-spin fa-spinner"></i> Deleting</template>
                    <template v-else><i class="fas fa-save"></i> Delete</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                id: this.$route.params.id,
                file: {},
                record: {},
                errors: {},
            }
        },

        computed: {

        },

        methods: {

            getFile(){
                //Send it
                this.$http.get('/files/edit/' + this.id)
                    .then(response => {
                        //Set the file
                        this.file = response.data.file;
                        this.record = response.data.record;

                        //Set the Types for the getRecordName file 
                        this.file.record = this.record;

                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteFile(){
                //Helpers
                this.saving = true;

                //Send it
                this.$http
                .post('/files/delete/'+this.file.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('File Deleted');

                    //Return to main list?
                    this.$router.push(this.$root.getUrl(this.file));
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;

                        //Alert
                        this.$toastr.e('Validation Errors Occurred');
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Delete File');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {
            //get the file?
            this.getFile();
        }
    }
</script>
